import PropTypes from 'prop-types';
import React from 'react';
import Card from 'components/Card';
import MediaQuery from 'react-responsive';
import DesktopPhaseCard from 'desktopPhaseCard';
import MobilePhaseCard from 'mobilePhaseCard';
import styles from 'styles/resourceCard';
import cx from 'classnames';
import { isOverdue } from '../../../../../../../utils/dateUtils';
import { hasActionableFlag } from '../../../../../../../utils/flagUtils';
import {
  determineUseActualMOT,
  determineComplete,
  determineMOTTitle,
  determineMOTColorCode,
  determineMOT,
} from '../../../../../../../utils/motUtils';
import ColoredButton from 'components/ColoredButton';
import { PhaseIndexType } from 'types/phase';
import phaseCardStyles from './phaseCard.scss';
import { CUT_POINT } from 'config/constants';
import moment from 'moment';

const getCardColorCode = (phase) => {
  const now = moment();
  const dueAt = moment(phase.effective_due_at);
  const dueAtEod = dueAt.clone().endOf('day');
  const dueToday = dueAt.isSameOrBefore(now.clone().endOf('day'));
  const hasActionable = hasActionableFlag(phase);
  if (dueToday && now.isSameOrAfter(dueAtEod)) {
    if (hasActionable) return 'red';
    return 'orange';
  }
  if (dueToday && hasActionable) return 'yellow';
  if (dueToday && now.isSameOrBefore(dueAtEod)) return 'green';
  return 'normal';
};

const isUnlinkButton = button => button.text === 'Unlink Phase';

const isMergeButton = button => button.text === 'Merge Phase';

const mergeUnavailable = (source, other) => [source.type, other.type].some(t =>
  ['Assessment', 'Installation'].includes(t));

const isMerged = (source, other) => source.merged_phases.includes(other.id.toString());

const PhaseCard = ((props) => {
  const { role, position, phase, surfaceType, actionButton, actionButton2,
          store, sourcePhase, ...otherProps } = props;
  const surfaceName = surfaceType ? surfaceType.name : '--';
  const overdue = isOverdue(phase.effective_due_at);
  const cardColorCode = getCardColorCode(phase);
  const complete = determineComplete(phase.status, phase.phase_tasks);
  const useActualMOT = determineUseActualMOT(phase.type, phase.appointments, complete);
  const motTitle = determineMOTTitle(phase.type, useActualMOT, complete);
  const motColorCode = determineMOTColorCode(phase, useActualMOT, complete);
  const mot = determineMOT(phase, useActualMOT);
  return (<Card key={`phase-${phase.id}`} className={styles.resourceCard}>
    <MediaQuery minWidth={CUT_POINT}>{(isDesktop) => {
      const Component = isDesktop ? DesktopPhaseCard : MobilePhaseCard;
      return (<Component
        role={role}
        position={position}
        phase={phase}
        surfaceName={surfaceName}
        overdue={overdue}
        cardColorCode={cardColorCode}
        motColorCode={motColorCode}
        motTitle={motTitle}
        mot={mot}
        storeInfo={store}
        lrrp={phase.lrrp_required}
        {...otherProps}
      />);
    }}
    </MediaQuery>
    {actionButton && <div
      className={cx(phaseCardStyles.phaseColumnFlex, phaseCardStyles.phaseCardActionModeRight)}
    >
      <ColoredButton
        label={actionButton.text}
        onClick={actionButton.onClick}
        hidden={isUnlinkButton(actionButton) && sourcePhase && isMerged(sourcePhase, phase)}
      />
    </div>}
    {actionButton2 && <div
      className={cx(phaseCardStyles.phaseColumnFlex, phaseCardStyles.phaseCardActionModeRight)}
    >
      <ColoredButton
        label={!isMergeButton(actionButton2) || !isMerged(sourcePhase, phase) ? actionButton2.text : 'Phase Merged'}
        onClick={actionButton2.onClick}
        disabled={isMergeButton(actionButton2) && sourcePhase && isMerged(sourcePhase, phase)}
        hidden={isMergeButton(actionButton2) && sourcePhase && mergeUnavailable(sourcePhase, phase)}
      />
    </div>}
  </Card>);
});

PhaseCard.defaultProps = { actionButton2: null, actionButton: null, sourcePhase: null };

PhaseCard.propTypes = {
  role: PropTypes.string,
  position: PropTypes.string,
  phase: PhaseIndexType.isRequired,
  sourcePhase: PhaseIndexType,
  surfaceType: PropTypes.shape({
    name: PropTypes.string,
  }),
  store: PropTypes.shape({
    number: PropTypes.string,
  }),
  actionButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
  actionButton2: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
};

export default PhaseCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/index.jsx